// import: styles
import { Box, Dialog } from '@mui/material';

// import: assets
import * as processingAnimationData from 'core/assets/lottie/paylink-processing.json';
import * as errorAnimationData from 'core/assets/lottie/payment-paylink-error.json';
import BaseButton from 'core/components/button/BaseButton';
import BaseTypography from 'core/components/typography/BaseTypography';

// import: config
// import: constants
import { ApiStage } from 'core/constants/enums/ApiStages.ts';

// import: components
import LottieAnimation from 'core/layouts/components/lottie-animation/LottieAnimation';
import { payLinkPopUpsStyles } from 'core/layouts/components/subscription-plans/components/pay-link-pop-ups/PayLinkPopUpsStyles';

// import: utils
// import: services
// import: redux
import {
	getPayLinkAPIStageSelector,
	setGetPayLinkAPIStage,
} from 'core/store/reducers/profileReducer/ProfileSlice';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import: lazy load components

function PayLinkPopUp() {
	const dispatch = useDispatch();

	const getPayLinkAPIStage = useSelector(getPayLinkAPIStageSelector);

	const open = useMemo(
		() => getPayLinkAPIStage === ApiStage.LOADING || getPayLinkAPIStage === ApiStage.ERROR,
		[getPayLinkAPIStage],
	);

	const onClose = () => {
		if (getPayLinkAPIStage === ApiStage.ERROR) {
			dispatch(setGetPayLinkAPIStage(ApiStage.IDLE));
		}
	};

	const lottieComp = useMemo(() => {
		if (getPayLinkAPIStage === ApiStage.LOADING) {
			return (
				<Box className="lottie-cont">
					<LottieAnimation animationData={processingAnimationData} />
				</Box>
			);
		}
		if (getPayLinkAPIStage === ApiStage.ERROR) {
			return (
				<Box className="lottie-cont">
					<LottieAnimation animationData={errorAnimationData} loop={false} />
				</Box>
			);
		}
		return null;
	}, [getPayLinkAPIStage]);

	const config = useMemo(() => {
		if (getPayLinkAPIStage === ApiStage.ERROR) {
			return {
				title: 'Payment unsuccessful',
				subTitle:
					'Something went wrong. Please try again. If the issue persists, please contact us.',
			};
		}
		return {
			title: 'Loading secure payment gateway',
			subTitle: '',
		};
	}, [getPayLinkAPIStage]);

	return (
		<Dialog
			id="processing-paylink-dialog"
			open={open}
			aria-labelledby="processing-paylink"
			onClose={onClose}
			disableEscapeKeyDown={getPayLinkAPIStage === ApiStage.ERROR}
			sx={payLinkPopUpsStyles.dialog}
		>
			<Box sx={[payLinkPopUpsStyles.popUp, payLinkPopUpsStyles.payLinkPopUp]}>
				{lottieComp}
				<Box sx={payLinkPopUpsStyles.textFlexCol}>
					<BaseTypography variant="t1_medium" styles={{ color: 'colors.light1' }}>
						{config.title}
					</BaseTypography>
					<BaseTypography variant="body1" styles={{ color: 'colors.light3' }}>
						{config.subTitle}
					</BaseTypography>
				</Box>
				{getPayLinkAPIStage === ApiStage.ERROR && (
					<BaseButton id="okay-button" styles={payLinkPopUpsStyles.okayButton} onClick={onClose}>
						<BaseTypography variant="b1_bold" styles={{ color: 'colors.dark6' }}>
							Okay
						</BaseTypography>
					</BaseButton>
				)}
			</Box>
		</Dialog>
	);
}

export default PayLinkPopUp;
